module.exports = __webpack_public_path__ + "media/starry-4k.ce49090b.mp4";